import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";

import * as S from "./styles";

const DEFAULT_DEEP_LINK_URL = "agroreceita://login-success";
const ANDROID_PACKAGE = "com.clienteagroreceita";
const DEFAULT_FALLBACK_PATH = "/login";
const TOKEN_STORAGE_KEY = "@agroReceita-Token";
const DEEP_LINK_ATTEMPT_KEY = "agroreceita_deeplink_attempted";

const LoginSuccess = () => {
  const baseDeepLinkUrl = process.env.REACT_APP_MOBILE_DEEP_LINK_URL || DEFAULT_DEEP_LINK_URL;

  const getFallbackPath = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("fallback") || DEFAULT_FALLBACK_PATH;
  };

  const getDeepLinkParams = () => {
    const params = new URLSearchParams(window.location.search);
    const token = localStorage.getItem(TOKEN_STORAGE_KEY);

    params.delete("fallback");

    if (token && !params.has("token")) {
      params.set("token", token);
    }

    const query = params.toString();
    return query ? `?${query}` : "";
  };

  const getDeepLinkUrl = () => {
    return `${baseDeepLinkUrl}${getDeepLinkParams()}`;
  };

  const getAndroidIntentUrl = () => {
    return `intent://login-success${getDeepLinkParams()}#Intent;scheme=agroreceita;package=${ANDROID_PACKAGE};end`;
  };

  const openApp = () => {
    const isAndroid = /Android/i.test(window.navigator.userAgent);
    window.location.href = isAndroid ? getAndroidIntentUrl() : getDeepLinkUrl();
  };

  useEffect(() => {
    const fallbackPath = getFallbackPath();

    if (sessionStorage.getItem(DEEP_LINK_ATTEMPT_KEY)) {
      sessionStorage.removeItem(DEEP_LINK_ATTEMPT_KEY);
      window.location.assign(fallbackPath);
      return;
    }

    // Always redirect after timeout — if the app truly opened, the user is
    // already in the app and won't see this redirect. Checking visibilitychange
    // or pagehide is unreliable: browsers may fire these even when the custom
    // scheme fails, which would block the redirect and leave the page stuck.
    const fallbackTimer = window.setTimeout(() => {
      sessionStorage.removeItem(DEEP_LINK_ATTEMPT_KEY);
      window.location.assign(fallbackPath);
    }, 3000);

    sessionStorage.setItem(DEEP_LINK_ATTEMPT_KEY, "1");
    openApp();

    return () => {
      window.clearTimeout(fallbackTimer);
    };
  }, []);

  return (
    <S.Container>
      <S.LoaderWrap>
        <S.Loading />
      </S.LoaderWrap>
    </S.Container>
  );
};

export default withRouter(LoginSuccess);
